import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    ticketHeader: {
      display: 'flex',
      // flexDirection: 'column',
      alignItems: 'center',
      padding: '0 16px',
      minHeight: '65px',
      justifyContent: 'space-between',
      zIndex: 1000,
      [theme.breakpoints.down('sm')]:{
        padding: '0'
      }
    }
  }))
  